module.exports = __webpack_public_path__ + "img/icon08.d0289dc0.png";